<div class="contentSection2">
  <div class="headerSection2">
    <span class="typography-title-m infoHeader">{{ 'new-galleries.subtitle-photo' | translate }}</span>
  </div>

  <ng-container *ngIf="images.length === 0; else galleryView">
    <div class="emptyStatus">
      <div class="hint vertical">
        <div class="classDescription">
            <span class="typography-title-l classTitle primaryDefault-color">{{ 'new-galleries.no-images' | translate}}</span>
        </div>
        <div class="classDescription">
            <span class="info">{{ 'new-galleries.images-accepted' | translate }}<br>{{ 'new-galleries.images-sizes' | translate}}</span>
        </div>
        <div *ngIf="errorMessages.length > 0" class="error-messages">
          <ul>
            <li *ngFor="let error of errorMessages" class="text-red-500">{{ error }}</li>
          </ul>
        </div>
        <app-button [class.disabled]="!creating" class="cosentino-button" [primary]="false" [secondary]="true" [ghost]="false" (onClick)="fileInput.click()" [size]="'large'">
            <span class="typography-body-m-medium oneLine">{{ 'new-galleries.button-add-image' | translate }}</span>
        </app-button>
        <input #fileInput type="file" accept=".jpg,.jpeg,.png" multiple (change)="creating && onFileSelected($event)" hidden>
      </div>
    </div>
  </ng-container>

  <ng-template #galleryView>
    <div class="gallery-grid">
      <div class="image-card" *ngFor="let image of images; let i = index">

        <div [class.disabled]="!creating" class="delete-icon" (click)="creating && deleteImage(i)">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M9 3V4H4V6H5V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V6H20V4H15V3H9ZM7 6H17V19H7V6ZM9 8V17H11V8H9ZM13 8V17H15V8H13Z" fill="#232323"/>
          </svg>
        </div>

        <img [src]="image.tempUrl || image.url" alt="Preview">

        <div class="form-section">
            <div *ngIf="applications">
                <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.aplicacion1' | translate }}</p>
                <app-select
                    [disabled]="!creating"
                    [placeholder]="'my_galleries.selecciona_una_aplicacion_d' | translate"
                    [options]="applicationOptions"
                    [selectedValue]="getSelectedApplication(i)"
                    (selectedValueChanged)="selectApplication(i, $event)">
                </app-select>
            </div>

            <div *ngIf="brands">
                <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.marca' | translate }}</p>
                <app-select
                    [disabled]="!creating"
                    [placeholder]="'my_galleries.selecciona_una_marca_d' | translate"
                    [options]="brandOptions"
                    [selectedValue]="getSelectedBrand(i)"
                    (selectedValueChanged)="selectBrand(i, $event)">
                </app-select>
            </div>

            <div *ngIf="colors">
                <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.image_color' | translate }}</p>
                <app-select
                    [disabled]="!creating"
                    [placeholder]="'my_sales.select_color' | translate"
                    [options]="getColorOptionsForIndex(i)"
                    [selectedValue]="getSelectedColor(i)"
                    (selectedValueChanged)="selectColor(i, $event)">
                </app-select>
            </div>

          <app-button
            class="cosentino-button L"
            [block]="true"
            [primary]="false"
            [secondary]="true"
            [ghost]="false"
            (onClick)="applyToAll(i)"
            [size]="'medium'"
            [disabled]="!creating"
          >
            <span class="typography-body-m-medium">
              {{ 'my_galleries.apply_to_all_photos' | translate }}
            </span>
          </app-button>

          <app-radio
            [checked]="image.isCover"
            label="{{ 'my_galleries.set_as_main_image' | translate }}"
            [class.disabled]="!creating"
            (onClick)="creating && setAsMainImage(i)"></app-radio>
        </div>
      </div>
    </div>
    <div *ngIf="errorMessages.length > 0" class="error-messages">
      <ul>
        <li *ngFor="let error of errorMessages" class="text-red-500">{{ error }}</li>
      </ul>
    </div>
    <div class="actions">
      <app-button class="cosentino-button w-full md:w-auto" [showIcon]="true" [iconType]="'add'"
            [primary]="false" [secondary]="true" [ghost]="false" (onClick)="triggerFileInput()"
            [size]="'large'" [disabled]="!creating || images.length >= 12">
        <span class="typography-body-m-medium oneLine">{{'new-galleries.button-add-image' | translate}}</span>
      </app-button>
      <!-- Input oculto para seleccionar nuevas imagenes -->
      <input
        #fileInput
        type="file"
        accept=".jpg,.png"
        multiple
        (change)="onFileSelected($event)"
        hidden
      />

      <app-button class="cosentino-button w-full md:w-auto" [secondary]="false" [ghost]="true" [iconType]="'delete'" [showIcon]="true"
        (onClick)="deleteAllImages()" [size]="'large'" [disabled]="!creating">
        <span class="typography-body-m-medium oneLine">{{ 'new-galleries.delete-all-images' | translate }}</span>
      </app-button>
    </div>
  </ng-template>
</div>
